module.exports = __webpack_public_path__ + "static/media/dobleProducto2.e2570c51.png";